import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse, IconButton, Typography, useTheme } from "@mui/material";
import React, { FC } from 'react';

interface CollapsibleSectionProps {
    title: string;
    isExpanded: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

/**
 * Reusable collapsible section component with header and toggle functionality
 */
const CollapsibleSection: FC<CollapsibleSectionProps> = ({
    title,
    isExpanded,
    onToggle,
    children
}) => {
    const theme = useTheme();

    return (
        <Box sx={{ mb: 3 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 2,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    pb: 1,
                    cursor: 'pointer'
                }}
                onClick={onToggle}
            >
                <Typography
                    variant="h6"
                    sx={{
                        color: theme.palette.text.primary,
                        fontWeight: theme.typography.fontWeightMedium,
                        flexGrow: 1
                    }}
                >
                    {title}
                </Typography>
                <IconButton size="small" sx={{ color: theme.palette.text.secondary }}>
                    {isExpanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
            </Box>
            <Collapse in={isExpanded}>
                {children}
            </Collapse>
        </Box>
    );
};

export default CollapsibleSection;
